import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Student_Point } from "../../shared/data.service";
import { PointTransactionInfo, PointTransactionRequest } from "../../shared/PointTransactionRequest";

@Component({
	selector: "app-student-pbis-redeem",
	templateUrl: "./student-pbis-redeem.component.html",
	styleUrls: ["./student-pbis-redeem.component.css"],
})
export class StudentPBISRedeemComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private PBISService: DataService_Student_Point,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.PersonID = this.dialogConfig.data.PersonID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.StudentID = this.dialogConfig.data.StudentID;
		this.StudentName = this.dialogConfig.data.StudentName;
		this.CurrentBalance = this.dialogConfig.data.CurrentBalance;

		this.loadPointItem();
	}

	//////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////

	CurrentBalance: any = 0;

	user: any;
	StudentID: any;
	StudentName: any;

	PersonID: any;
	SchoolID: any;

	SelectedPoint: any;
	lstPoints: any = [];

	ItemLoading: any = true;
	Processing: any = false;

	errorMessage: any = "";

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////
	loadPointItem() {
		this.ItemLoading = true;

		var result = this.PBISService.PBISPointItemSelectList(2, this.SchoolID); //2 for Academic? / Redeem?
		result.subscribe(
			(response) => {
				this.lstPoints = response;

				this.SelectedPoint = this.lstPoints[0];

				this.ItemLoading = false;
			},
			(error) => {
				this.ItemLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////
	onAdd() {
		if (this.lstPoints.length == 0) {
			return;
		}

		if (this.SelectedPoint.PointsItemValue > this.CurrentBalance) {
			this.errorMessage = "Not enough points to redeem";
			return;
		}

		this.Processing = true;

		//
		// Create Request
		//

		let lstTransact: PointTransactionInfo[] = [];

		let tran: PointTransactionInfo = {
			PersonID: this.PersonID,
			PointsTransactionTypeID: 2, //Redeem point
			PointsItemValue: this.SelectedPoint.PointsItemValue,
			PointsItemID: this.SelectedPoint.PointsItemID,
			SchoolID: this.SchoolID,
		};

		lstTransact = [...lstTransact, tran];

		let parms: PointTransactionRequest = {
			c_PersonID: this.user.personID,
			transactionlist: lstTransact,
		};

		//
		// Call SP
		//

		var result = this.PBISService.TransactionInsert(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "redeem",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Points were redeemed successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "redeem",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not redeem points",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////////

	onPointChange(val) {
		this.SelectedPoint = val;

		this.errorMessage = "";
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.ItemLoading || this.Processing;
	}

	//////////////////////////////////////////////////////////////////
}
